declare const VERSION: string;

export const logAppVersion = (appName: string) => {
    console.log(`[${appName}] v${VERSION}`);
};
